import React, { useRef, useState } from "react";
import { Ticket, Loader2 } from "lucide-react";
import { playTearSound } from "@/lib/sound";

export default function ClaimCouponButton({ onClaim, claiming, testId, label = "Richiedi coupon" }) {
  const ref = useRef(null);
  const [tearing, setTearing] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    if (claiming || tearing) return;
    const el = ref.current;
    setTearing(true);
    playTearSound();
    setTimeout(() => {
      onClaim(el);
      setTimeout(() => setTearing(false), 500);
    }, 420);
  };

  const Face = (
    <>
      {claiming ? <Loader2 className="h-4 w-4 animate-spin" /> : <Ticket className="h-4 w-4" />}
      {label}
    </>
  );

  return (
    <button
      ref={ref}
      data-testid={testId}
      onClick={handleClick}
      disabled={claiming}
      className={`cc-btn mt-auto w-full h-9 text-white font-bold text-xs hover:opacity-90 transition-opacity disabled:opacity-60 ${tearing ? "cc-tearing" : ""}`}
    >
      <span className="cc-half left kn-gradient">{Face}</span>
      <span className="cc-half right kn-gradient">{Face}</span>
      <span className="cc-notch t" aria-hidden="true" />
      <span className="cc-notch b" aria-hidden="true" />
      <span className="cc-perf" aria-hidden="true" />
    </button>
  );
}
